export default "__VITE_ASSET__Dcy8h0xy__"